import AppChoose from "./app-choose-us";
import AppHeader from "./app-header";
import AppSolutions from "./app-solutions";

const HomePage = () => (
  <div>
    <AppHeader></AppHeader>
    <AppSolutions></AppSolutions>
    <AppChoose></AppChoose>
    {/* <AppClients></AppClients> */}
  </div>
);

export default HomePage;